exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-drawer-btn[data-v-a146668c]{background-color:#f44336!important;color:#fff!important}.close-drawer-btn[data-v-a146668c]:hover{background-color:#d32f2f!important}.close-drawer-btn .v-icon[data-v-a146668c]{color:#fff!important}", ""]);

// exports
